<template>
  <WorkspaceChatHeader @update:ticket="$emit('update:ticket')" :isChat="true" :inCall="hasActiveCallTicket" />

  <div v-if="isSms" class="warning">
    El canal de SMS permite por ahora únicamente envío de plantillas sin
    <br />
    respuesta del contacto.
  </div>

  <div
    class="chat__container"
    :class="{ 'no-input': isSms }"
    :style="getBackground()"
    v-if="history"
  >
    <WorkspaceChatHistory
      ref="chatHistory"
      :history="history"
      :expanded="true"
      :channelId="channel?.channel?.id"
      :inputHeight="inputHeight"
      :disabled="isBlockedByBalance || isBlockedByTimeout"
    />
    <VisitorTypingIndicator
      :isVisible="showVisitorTyping"
      class="chat__typing"
    />
    <InputSection
      v-if="channel?.channel?.id !== ChannelType.Sms"
      class="chat__input"
      :channelId="channel?.channel?.id"
      :disabled="isBlockedByBalance || isBlockedByTimeout"
      :tooltipText="tooltipText"
      @sended="handleMessageSent"
    />
  </div>

  <div v-else class="skeleton">
    <a-skeleton active />
    <a-skeleton active />
  </div>
</template>

<script>
import { inject, provide, ref } from "vue";
import { debounce } from "lodash";

import { ChannelType } from "@/app/shared/utils/enums";
import EventBus from "@/app/shared/utils/eventBus";

import WorkspaceChatHeader from "@/app/workspace/components/chat/WorkspaceChatHeader.vue";
import WorkspaceChatHistory from "@/app/workspace/components/chat/WorkspaceChatHistory.vue";
import InputSection from "@/app/workspace/components/chat/input/InputSection.vue";
import VisitorTypingIndicator from "@/app/workspace/components/chat/VisitorTypingIndicator.vue";

import backgroundImage from "@/app/workspace/assets/bg.webp";
import { EventManagement } from "@/app/shared/utils/enums";
import { registerEventManagement } from "@/app/shared/services";
import { CallStatus } from "@/packages/vue-jssip/jssip/phone";
import { safeRegisterEventManagement } from "@/app/shared/composables/useRegisterEventManagement";

export default {
  components: {
    WorkspaceChatHeader,
    WorkspaceChatHistory,
    InputSection,
    VisitorTypingIndicator,
  },
  props: {
    isChat: {
      type: Boolean,
      default: false,
    },
  },
  setup() {
    const ticket = inject("selectedTicket");
    // This is now the interaction
    const channel = inject("selectedChannel");
    const responseContext = ref();
    provide("responseContext", responseContext);

    const getBackground = () => `background-image: url(${backgroundImage})`;

    return { ticket, channel, ChannelType, getBackground };
  },
  data() {
    return {
      typingTimeout: null,
      typingTicketId: null,
    };
  },
  computed: {
    isSms() {
      return this.channel?.channel?.id === ChannelType.Sms;
    },
    user() {
      return this.$store.getters["getDataUser"];
    },
    hasActiveCallTicket() {
      const ticketId = this.$route.query?.ticket;
      if (!this.$jssip || !this.$jssip.phone) return false;
      const jssipStatus = this.$jssip.phone.status;
      const isInACall = jssipStatus == CallStatus.Connecting ||
        jssipStatus == CallStatus.Ringing ||
        jssipStatus == CallStatus.InCall;

      return isInACall && this.$jssip.phone.isCurrentCallTicket(ticketId);
    },
    dataUserState() {
      return this.$store.getters["getDataUserState"];
    },
    history() {
      const data = this.$store.getters["getWorkspaceMessageHistory"];

      if (!data) {
        return [];
      }

      const messages = data.messages || [];
      const summaries = data.summaries || [];
      const summaryWorspace = summaries.filter((summary) => summary.origin === "workspace");

      const messageHistory = [
        ...messages.map((message) => ({ ...message, type: "message" })),
        ...summaryWorspace.map((summary) => ({ ...summary, type: "summary" })),
      ];

      const sortedMessages = messageHistory.sort(
        (a, b) => new Date(a.created_at) - new Date(b.created_at)
      );

      console.log(sortedMessages, "FINAL ARRAY MESSAGES");

      return sortedMessages;
    },
    isBlockedByBalance() {
      const lastMessage = this.history.at(-1);

      return lastMessage?.blocked;
    },
    isBlockedByTimeout() {
      return this.channel?.blocked;
    },
    showVisitorTyping() {
      const isTyping = this.$store.getters["getIsVisitorTyping"];
      if (!isTyping) return false;
      const currentTicketId = Number(this.$route.query.ticket);
      return this.typingTicketId === currentTicketId;
    },
    tooltipText() {
      if (this.isBlockedByBalance)
        return "No cuenta con saldo suficiente para enviar un mensaje de whatsapp";

      if (this.isBlockedByTimeout) {
        const channelId = this.channel?.channel?.id;

        switch (channelId) {
          case ChannelType.Whatsapp:
            return "Han pasado más de 24h sin respuesta del contacto o has enviado una plantilla y no hay respuesta.";

          case ChannelType.Inbound:
            return "Se ha excedido el tiempo de inactividad por parte del contacto o ha reiniciado su Web Chat.";

          default:
            break;
        }
      }

      return "";
    },
  },
  async created() {
    await this.fetchHistory();

    EventBus.on("updateHistory", () => {
      console.log("updateHistory");
      this.fetchHistory();
    });

    // if (this.ticket.unread_messages) {
    //   await refreshTickets({
    //     customer_id: this.user?.customer?.id,
    //     iduser: this.user?.id,
    //   });
    // }
  },
  beforeUnmount() {
    if (this.typingTimeout) {
      clearTimeout(this.typingTimeout);
    }
  },
  async mounted() {
    console.log(this.$store.getters["getEventMessaging"], 'this.$store.getters["getEventMessaging"]')
    if (this.$store.getters["getEventMessaging"] == -1) {
      this.registerEvent(EventManagement.Opened);
    }
  },
  methods: {
    async fetchHistory(prevent = false) {
      // detecta si esta al final del scroll antes de obtener nuevos mensajes
      let isAtBottom = true;
      if (this.$refs.chatHistory) {
        isAtBottom = this.$refs.chatHistory.isAtBottom();
      }

      // proceso de fetch history
      const ticketId = this.$route.query.ticket;
      const interactionId = this.$route.query.interaction;
      const payload = { ticket: ticketId, interaction: interactionId, prevent, isWorkspace: true };
      if (this.isChat) await this.$store.dispatch("fetchHistoryByTicket", payload);

      // despues de obtener nuevos mensajes si esta al final del scroll, hacer scroll al final
      if (isAtBottom && this.$refs.chatHistory && this.isChat) {
        this.$nextTick(() => {
          this.$refs.chatHistory.scrollToBottom();
        });
      }
    },
    handleMessageSent() {
      this.fetchHistory(true);
    },
    async registerEvent(event) {
      const ticket = this.$route.query.ticket;
      await safeRegisterEventManagement(event, {
        open_ticket: ticket,
        menu: 23,
        state: this.dataUserState,
        module: 'workspace-chat-section',
      });
      this.$store.dispatch("setEventMessaging", event);
    },
    handleTypingIndicator({ ticket_id, status }) {
      if (status === "typing") {
        this.typingTicketId = ticket_id;
        this.$store.dispatch("setVisitorTyping", true);

        if (this.typingTimeout) clearTimeout(this.typingTimeout);
        this.typingTimeout = setTimeout(() => {
          this.$store.dispatch("setVisitorTyping", false);
          this.typingTicketId = null;
        }, 10000);
      } else {
        if (this.typingTimeout) clearTimeout(this.typingTimeout);
        this.$store.dispatch("setVisitorTyping", false);
        this.typingTicketId = null;
      }
    },
  },
  sockets: {
    refreshHistory: debounce(function ({ ticketid }) {
      if (ticketid != this.$route.query.ticket) return;
      console.log(new Date().toLocaleTimeString());
      this.fetchHistory(true);
    }, 1000),
    typingIndicator(data) {
      this.handleTypingIndicator(data);
    },
  },
};
</script>

<style lang="sass" scoped>
.skeleton
  padding: 0 8px

.chat
  &__container
    // height: calc(100% - 118px)
    // height: calc(100% - 167px)
    // height: 100%
    display: flex
    flex-direction: column
    flex: 1 1 auto
    min-height: 0

    &.no-input
      // height: calc(100% - 118px)

  &__input
    justify-self: flex-end

  &__typing
    flex-shrink: 0

.warning
  background-color: #FFE58F
  color: $text-primary
  font-size: 12px
  text-align: center
  padding: 4px 12px
</style>
